import { useTranslation } from "react-i18next";
import "./buttonNew.scss";
import { IButtonEitherLabelOrChildrenProps, IButtonProps } from "./buttonPropertiesInterfaceNew";

interface IProps extends IButtonProps {
  type?: "button" | "submit" | "reset" | undefined;
}

export default function Button({ type, disabled, prefix, sufix, onClick, onKeyDown, className, color, noBlock, noMargin, reference, isBlockButton, ...props }: IProps & IButtonEitherLabelOrChildrenProps) {
  const { t } = useTranslation();

  const buildContent = () => {
    if ('label' in props && props.label.length > 0) {
      return t(props.label);
    }

    return (('children' in props) ? props.children : <></>);
  };

  const getClasses = (): string => {
    let classes: string = `${isBlockButton ? 'block-button' : 'button-new'} btn-new btn `;
    if(color === "transparent"){
      classes += `btn bg-transparent border-0 `;
    }else if(color === "white" && disabled){
      classes += `btn-dark `;
    }else{
      classes += `${(color) ? `btn-${color} ` : 'btn-primary '} `;
    }
    classes += `${(disabled) ? 'disabled ' : ''} `;
    classes += `${(noBlock) ? 'ps-4 pe-4 ' : '' } `;
    classes += `${(noMargin) ? 'mt-0 ' : '' } `;
    classes += `${className || ''}`;
    
    return classes;
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (disabled) return;
    if (typeof onClick === 'function') {
      onClick(); 
    }
  };

  return (
    <button
      className={getClasses()}
      type={type || 'button'}
      disabled={disabled}
      onClick={handleClick}
      onKeyDown={onKeyDown}
      tabIndex={0}
      ref={reference}
    >
      {
        prefix &&
        <span className={`prefix ${disabled && "svg-white"}`}>{prefix}</span>
      }
      {buildContent()}
      {
        sufix &&
        <span className="sufix">{sufix}</span>
      }
    </button>
  );
}
